<template>
  <v-dialog v-model="getRadecProductImageOptions.dialog" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar flat height="40px" color="#000039">
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="2">
            <span class="primary--text caption">{{getRadecProductImageOptions.matnr}}</span>
          </v-col>
          <v-col cols="10">
            <span class="secondary--text overline">{{getRadecProductImageOptions.desc}}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-img
        v-if="getRadecProductImageOptions.matnr"
        max-height="450"
        contain
        :lazy-src="
							`https://www.radec.com.mx/sites/all/files/imagecache/product_list/productos/${getRadecProductImageOptions.matnr}.jpg`
						"
        :src="
							`https://www.radec.com.mx/sites/all/files/productos/${getRadecProductImageOptions.matnr}.jpg`
						"
        alt="RADEC"
      ></v-img>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    data: () => ({}),
    computed: mapGetters(["getRadecProductImageOptions"]),
    watch: {},
    created() {},
    mounted() {},
    methods: {
      closeDialog() {
        this.$store.commit("updateRadecProductImageOptions", {
          dialog: false,
          matnr: ""
        });
      }
    }
  };
</script>

<style scoped>
</style>




